export default "__VITE_ASSET__ebd84e13__"